import axios from "axios";
import authHeader from "../../Services/auth-header";
import { refreshToken } from "../../Services/auth.service";
import { baseURLUploadImg, baseURLUploadPdf } from "../../Services/client";
import { ShowLogin2Modal } from "../../Actions/types";

export function retryAxiosPost(
  url,
  formData,
  config,
  onSuccess,
  onFail,
  retries = 1,
  delay = 30000
) {
  axios
    .post(url, formData, config)
    .then(onSuccess)
    .catch((err) => {
      console.log("Upload error:", err);

      if (err.response && err.response.status === 401) {
        refreshToken().then((response2) => {
          if (response2 !== false) {
            retryAxiosPost(url, formData, config, onSuccess, onFail, retries, delay);
          } else {
            onFail(err);
          }
        });
      } else if (retries > 0) {
        setTimeout(() => {
          console.log("Retrying upload...");
          retryAxiosPost(url, formData, config, onSuccess, onFail, retries - 1, delay);
        }, delay);
      } else {
        onFail(err);
      }
    });
}

export function createSubmitUploadedFile({
  selectedFile,
  editedFileName,
  setIsUploading,
  setSelectedFile,
  setSelectedFileName,
  setEditedFileName,
  modalHandleClose,
  addUploadFileUrl,
  dispatch,
}) {
  return function submitUploadedFile(PDFOrImg, file) {
    setIsUploading(true);

    let extensionSearch = /(?:\.([^.]+))?$/;
    let extension;
    let newFile;
    if (selectedFile === undefined) {
      extension = extensionSearch.exec(file.name)[1];
      newFile = new File(
        [file],
        editedFileName === "" ? file.name : editedFileName + "." + extension,
        { type: `${file.type}` }
      );
    } else {
      extension = extensionSearch.exec(selectedFile.name)[1];
      newFile = new File(
        [selectedFile],
        editedFileName === "" ? selectedFile.name : editedFileName + "." + extension,
        { type: `${selectedFile.type}` }
      );
    }

    const formData = new FormData();
    formData.append("File", newFile);
    formData.append("UserFileName", newFile.name);

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        ...authHeader(),
      },
    };

    const url = PDFOrImg === 1 ? baseURLUploadPdf : baseURLUploadImg;

    const onSuccess = (response) => {
      setIsUploading(false);
      addUploadFileUrl(response.data, newFile.name, PDFOrImg, newFile);
      setSelectedFile(undefined);
      setSelectedFileName("");
      setEditedFileName("");
      modalHandleClose(PDFOrImg === 1 ? "uploadPdf" : "uploadImg");
    };

    const onFail = (err) => {
      setIsUploading(false);
      setSelectedFile(undefined);
      setSelectedFileName("");
      setEditedFileName("");
      modalHandleClose(PDFOrImg === 1 ? "uploadPdf" : "uploadImg");

      dispatch({
        type: ShowLogin2Modal,
      });
    };

    retryAxiosPost(url, formData, config, onSuccess, onFail, 1, 30000); // یکبار بعد از ۳۰ ثانیه تلاش مجدد
  };
}
